/** Maximum number of keyword lists a single user can create. */
export const MAX_LISTS_PER_USER = 25;

/** Maximum number of keywords allowed in a single keyword list. */
export const MAX_KEYWORDS_PER_LIST = 500;

/** Maximum number of keywords that can be added in a single request. */
export const MAX_KEYWORDS_PER_ADD = 100;
